import { render, staticRenderFns } from "./ModificarRespuesta.vue?vue&type=template&id=367ffc1d&scoped=true&lang=pug&"
import script from "./ModificarRespuesta.vue?vue&type=script&lang=js&"
export * from "./ModificarRespuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ffc1d",
  null
  
)

export default component.exports